import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { workspaceApi, type WorkspaceType } from '../../api/workspaces';

export function WorkspaceCreatePage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [type, setType] = useState<WorkspaceType>('general');
  const [activate, setActivate] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const created = await workspaceApi.create({ name, slug: slug || undefined, type, activate, timezone: 'Asia/Kolkata' });
      navigate(`/workspaces/${created.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Create failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/workspaces" className="text-sm text-slate-600 hover:underline">← Workspaces</Link>
      <h1 className="mt-4 text-2xl font-semibold">Create workspace</h1>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      <form onSubmit={onSubmit} className="mt-6 space-y-4 rounded-xl border bg-white p-6">
        <label className="block"><span className="text-sm font-medium">Name *</span>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full rounded-lg border px-3 py-2" /></label>
        <label className="block"><span className="text-sm font-medium">Slug</span>
          <input value={slug} onChange={(e) => setSlug(e.target.value)} className="mt-1 w-full rounded-lg border px-3 py-2" /></label>
        <label className="block"><span className="text-sm font-medium">Type</span>
          <select value={type} onChange={(e) => setType(e.target.value as WorkspaceType)} className="mt-1 w-full rounded-lg border px-3 py-2">
            <option value="general">General</option><option value="brand">Brand</option><option value="marketplace">Marketplace</option>
            <option value="ai">AI Operations</option><option value="reporting">Reporting</option>
          </select></label>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={activate} onChange={(e) => setActivate(e.target.checked)} /> Activate immediately</label>
        <button type="submit" disabled={saving} className="rounded-lg bg-slate-900 px-4 py-2 text-white">{saving ? 'Creating…' : 'Create'}</button>
      </form>
    </div>
  );
}
